<ng-container *transloco="let t; read: 'core.pushNotificationPromptComponent'">
  <h2 mat-dialog-title class="mat-title-style">
    <mat-icon>notifications_none</mat-icon>
    {{t('heading')}}
  </h2>

  <div mat-dialog-content class="mat-dialog-style">
    <div class="message">
      @if(!data?.notificationPermission || data?.notificationPermission == 'denied') {
        <p class="title mb-3">{{t('msg5')}}</p>
      }
      @else {
      <p class="title mb-0">{{t('msg1')}}</p>
      <ol [innerHTML]="t('msg2')"></ol>
    }
    <p style="color: #ca8a03;" class="mb-3">
      @if(!data?.notificationPermission || data?.notificationPermission == 'denied'){
        <span> {{t('msg32')}} </span>
      }
      @else {
      <span> {{t('msg31')}} </span> <span> {{t('msg32')}} </span>
    }

  </p>
  @if (platform != 'ios' && platform != 'mac') {
    <p class="browser-platform" class="mb-3" [innerHTML]="t('msg4', { browser, platform })"></p>
  }
  @if (platform == 'ios' || platform == 'mac' ) {
    <p>{{t('macMsg1')}}</p>
    <ol [innerHTML]="t('macMsg2')"></ol>
  }
  @if (platform == 'ios' ) {
    <p class="mb-3">{{t('iosMsg1')}}</p>
    <ul>
      <li>
        {{t('iosMsg2')}}
        <a href="https://support.apple.com/en-in/guide/iphone/iph42ab2f3a7/16.0/ios/16.0#iph4f9a47bbc" target="_blank">
          https://support.apple.com/en-in/guide/iphone/iph42ab2f3a7/16.0/ios/16.0#iph4f9a47bbc
        </a>
      </li>
      <li>
        {{t('iosMsg3')}}
        <a href="https://support.apple.com/en-in/guide/iphone/iph7c3d96bab/16.0/ios/16.0" target="_blank">
          https://support.apple.com/en-in/guide/iphone/iph7c3d96bab/16.0/ios/16.0
        </a>
      </li>
    </ul>
  }
  @if (platform != 'ios' && platform != 'mac') {
    @if ( browser == 'chrome') {
      <p  class="mb-3" [innerHTML]="t('clickHere', {url: 'https://support.google.com/chrome/answer/3220216#zippy=%2Cfix-issues-with-notifications'})"></p>
    }
    @if (browser == 'firefox') {
      <p class="mb-3" [innerHTML]="t('clickHere', {url: 'https://support.mozilla.org/en-US/kb/push-notifications-firefox#w_how-do-i-revoke-web-push-permissions-for-a-specific-site'})"></p>
    }
    @if (browser == 'opera') {
      <p class="mb-3" [innerHTML]="t('clickHere', {url: 'https://help.opera.com/en/latest/web-preferences/#notifications'})"></p>
    }
    @if (browser == 'opera-mini') {
      <p class="mb-3" [innerHTML]="t('clickHere', {url: 'https://help.opera.com/en/latest/web-preferences/#notifications'})"></p>
    }
  }
</div>
</div>

<div mat-dialog-actions class="action-buttons">
  @if(!data?.notificationPermission || data?.notificationPermission == 'denied') {
    <button mat-button mat-stroked-button class="btn-dark" [mat-dialog-close]="false">
      {{t('ok')}}
    </button>
  }
  @else {
  <button mat-button mat-stroked-button class="btn-dark"
    [mat-dialog-close]="false">
    {{t('noThanks')}}
  </button>
  <button cdkFocusInitial mat-raised-button color="primary" (click)="confirmClick()" class="btn-dark">
    {{t('allow')}}
  </button>
}
</div>

</ng-container>